export default __webpack_public_path__ + "static/media/photo--sm--80.50b2c96e.jpg";